import { GET_BOOKING_STATUS_FAILED_HANDLER } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case GET_BOOKING_STATUS_FAILED_HANDLER:
      action.payload.iscreate = action.isCreate
      return action.payload;
    default:
      return state;
  }
};
